<template>
  <router-link :to="'/' + subdomain + '/'"
    :class="['navbar-brand d-inline-flex align-items-center align-items-md-start justify-content-center justify-content-md-start', subdomain]">
    <template v-if="subdomain === 'carmens-best'">
      <img
        v-if="webDesign !== null && webDesign.design !== null"
        :src="webDesign.design.logo"
        class="d-inline-block align-top object-fit-contain"
        alt
        height="60"
      />
      <img
        src="@/assets/images/carmens_logo.jpg"
        width="60"
        class="d-inline-block align-top"
        alt
        v-else
      />
    </template>
    <template v-else-if="subdomain === 'bistrobff'">
      <img
        v-if="webDesign !== null && webDesign.design !== null"
        :src="webDesign.design.logo"
        class="d-inline-block align-top object-fit-contain"
        width="230"
        alt="Logo"
      />
      <img
        alt="Logo"
        width="230"
        src="https://s3.ap-southeast-1.amazonaws.com/rush-revamp.loyaltyco.xyz/production/merchant/cms/logo_image/bistro.png"
        class="d-inline-block align-top"
        v-else
      />
    </template>
    <template v-else-if="subdomain === 'generika'">
      <img
        v-if="webDesign !== null && webDesign.design !== null"
        :src="webDesign.design.logo"
        class="d-inline-block align-top object-fit-contain"
        width="80"
        alt
      />
      <img
        src="@/assets/images/generika_logo.jpg"
        alt="Generika"
        width="80"
        class="d-inline-block align-top"
        v-else
      />
    </template>
    <template v-else-if="subdomain === 'ucoin'">
      <img
        src="@/assets/images/ucoin_logo.png"
        class="d-inline-block align-top object-fit-contain"
        width="150"
        alt
      />              
    </template>
    <template v-else-if="subdomain === 'dunkin-donuts'">
      <img
        v-if="webDesign !== null && webDesign.design !== null"
        :src="webDesign.design.logo"
        class="d-inline-block align-top object-fit-contain"
        width="120"
        alt
      />
      <img
        src="@/assets/images/dunkin_donut_logo.jpg"
        alt="Dunkin Donuts"
        width="120"
        v-else
      />
    </template>
    <template v-else-if="subdomain === 'secretkitchen'">
      <img
        v-if="webDesign !== null && webDesign.design !== null"
        :src="webDesign.design.logo"
        class="d-inline-block align-top object-fit-contain"
        width="120"
        alt
      />
      <img
        src="@/assets/images/secret-kitchen_logo.jpg"
        alt="Secret Kitchen"
        width="120"
        v-else
      />
    </template>
    <template v-else-if="subdomain === 'multi-m'">
      <img
        :src="webDesign.design.logo"
        height="60"
        class="d-inline-block align-top object-fit-contain"
        width="80"
        alt
        v-if="webDesign !== null && webDesign.design.logo !== null"
      />
      <img
        src="@/assets/images/multi-m-logo.png"
        alt="Secret Kitchen"
        width="80"
        class="object-fit-contain"
        v-else
      />
    </template>
    <template v-else-if="subdomain === 'ecb'">
      <img
        :src="webDesign.design.logo"
        class="d-inline-block align-top object-fit-contain"
        width="80"
        alt
        v-if="webDesign !== null && webDesign.design.logo !== null"
      />
      <img
        src="@/assets/images/ecb-logo.jpg"
        alt="Secret Kitchen"
        width="80"
        class="object-fit-contain"
        v-else
      />
    </template>
    <template v-else>
      <img
        v-if="webDesign !== null && webDesign.design !== null"
        :src="webDesign.design.logo"
        width="185"
        height="60"
        class="d-inline-block align-top object-fit-contain"
        alt
      />
      <img
        src="@/assets/images/company-logo.png"
        width="50"
        height="50"
        class="d-inline-block align-top"
        alt
        v-else
      />
      <span v-if="webDesign === null || webDesign.design === null ">Company</span>
    </template>
  </router-link>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("merchant", {
      subdomain: state => state.subdomain
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign
    })
  }
}
</script>

<style lang="scss" scoped>
.navbar-brand.dunkin-donuts,
.navbar-brand.secretkitchen {
  max-height: 85px;
  overflow: hidden;
  display: flex !important;
  align-items: center !important;
}
a.navbar-brand.secretkitchen img {
  position: relative;
  top: -3px;
  max-height: 85px;
  width: auto;
}
</style>
